// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTermAcceptances_HistoryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /lgpd_term_acceptances/by_cliente/{id}
 *
 * Returns the consent history for a single client (newest first).
 */
import type { LgpdTermAcceptances_HistoryRow } from './LgpdTermAcceptances_HistoryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type LgpdTermAcceptances_HistoryResponseDados = LgpdTermAcceptances_HistoryRow[];

export type LgpdTermAcceptances_HistoryResponse = ApiResponse<LgpdTermAcceptances_HistoryResponseDados>;

registerResponseContract('LgpdTermAcceptances_HistoryResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: true },
      term_id:           { type: 'number',  required: true },
      cliente_id:        { type: 'number',  required: true },
      termo_titulo:      { type: 'string',  required: true },
      termo_versao:      { type: 'string',  required: true },
      termo_conteudo:    { type: 'string',  required: true },
      ip_address:        { type: 'string',  required: false },
      user_agent:        { type: 'string',  required: false },
      recorded_by:       { type: 'string',  required: false },
      created_at:        { type: 'string',  required: false },
      termo_titulo_join: { type: 'string',  required: false },
      termo_versao_join: { type: 'string',  required: false },
    },
  },
})
